import React from 'react';
import DeliveryOptionIcon from '../_utils/_delivery-options/delivery-option-icon';

const DeliveryOptionAdjustments = ({ prints, prismItems, adjustments }) => {
  if (adjustments.length === 0) {
    return null;
  }

  const message = adjustments.length == 1
    ? 'An item had an invalid delivery option'
    : `${adjustments.length} items had invalid delivery options`;

  const $adjustments = adjustments.map((itemId, i) => {
    const item = itemId
      ? prismItems.find((item) => item.id == itemId) // prism items
      : prints;

    const deliveryOption = (item.delivery_options || []).find(d => d.key == item.delivery);

    return (
      <li key={i}>
        {item.title || 'Prints'} has changed to <DeliveryOptionIcon option={deliveryOption} hideIcon />
      </li>
    );
  });

  return (
    <div className="alert alert-info">
      <button type="button" className="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
      <h5>{message}</h5>
      <ul>
        {$adjustments}
      </ul>
    </div>
  );
};

export default DeliveryOptionAdjustments;
